export const NODE_WIDTH = 20;
export const NODE_PADDING = 60;
export const INTEGRATION_TIMES = 20;
export const THIN_HEIGHT_BUFFER = 4;
export const NUMBER_OF_RECAL_THIN_CHART = 10;
export const RECAL_HEIGHT_INCREASE = 50;

export const NODE_NAMES = {
  REVENUE: 'revenue',
  SUM_SEGMENTS: 'sum_segments',
  REVENUE_ELIMINATION: 'revenue_elimination',
  OTHER_REVENUE: 'other_revenue',
  EXPENSES: 'expenses',
  GENERAL_ADMIN_EXPENSE: 'operating_expenses_general_administration',
  RESEARCH_DEVELOPMENT_EXPENSE: 'operating_expenses_research_development',
  SALES_MARKETING_EXPENSE: 'operating_expenses_sales_marketing',
  DEPRECATION_AMORTISATION_EXPENSE:
    'operating_expenses_depreciation_amortisation',
  NON_OPERATING_EXPENSE: 'operating_expenses_non_operating',
  OTHER_EXPENSE: 'operating_expenses_other',
  EARNINGS_GAIN: 'earnings_gain',
  EARNINGS_LOSS: 'earnings_loss',
  GROSS_PROFIT: 'gross_profit',
  LOSS_GROSS_PROFIT: 'loss_gross_profit',
  COST_OF_SALES: 'cost_of_sales',
};

export const GROUP_TYPES = {
  INCOME: 'Income',
  COST_REVENUE: 'CostRevenue',
  EXPENSES: 'Expenses',
  PROFIT: 'Profit',
  LOSS: 'Loss',
  REVENUE_ELIMINATION: 'Revenue Elimination',
};

export const tooltipMapping = {
  segment: `Segment revenue shows the company’s total revenues broken down into business unit, product/service types or geographies.`,
  [NODE_NAMES.OTHER_REVENUE]:
    'Other revenues that have not been attributed to a specific business unit, product/service or geography.',
  [NODE_NAMES.REVENUE]:
    'Total money earned by a company during the reporting period.',
  [NODE_NAMES.COST_OF_SALES]:
    'Costs directly attributable to producing a product or a service such as raw materials and labour.',
  [NODE_NAMES.GROSS_PROFIT]:
    'Revenue less cost of sales; the amount available before deducting operating and non-operating expenses.',
  [NODE_NAMES.LOSS_GROSS_PROFIT]:
    'Revenue less cost of sales; the amount available before deducting operating and non-operating expenses.',
  [NODE_NAMES.EARNINGS_GAIN]:
    'The residual profit made by a company after deducting all expenses, including operating and non-operating expenses, from total revenue. It indicates how much money the company has earned or lost during a specific time period and is a measure of its profitability.',
  operating_expenses:
    'Expenses that are necessary for the day-to-day running of the business but not direct inputs to the production of goods or services.',
  [NODE_NAMES.GENERAL_ADMIN_EXPENSE]:
    'Day-to-day costs a business must incur to operate. These include rent, office supplies, insurance and employee costs.',
  [NODE_NAMES.RESEARCH_DEVELOPMENT_EXPENSE]:
    'Costs of developing new or improving existing products and services.',
  [NODE_NAMES.SALES_MARKETING_EXPENSE]:
    'Expenses related to promoting the business or its products and services to engage or acquire more customers.',
  [NODE_NAMES.OTHER_EXPENSE]:
    'Other costs of normal operations and non-cash operating expenses including depreciation and amortization (decreases in asset values).',
  // expense_interest: `Total amount of interest payable on the company's borrowings less any interest income from deposits.`,
  // expense_income_tax:
  //   'Tax liability owed by the company over the course of the reporting period.',
  // expense_restructuring: 'Costs incurred to reorganIze business operations.',
  // expense_writedowns:
  //   'Reductions in the values of an asset due to the asset’s estimated economic profit potential declining.',
  // expense_investment_gains_losses:
  //   'Gains arising from the sale of assets or investments.',
  // expense_one_off_other: 'Other non-operating costs including one-offs.',
  // net_income:
  //   'Total profits or income from revenues after accounting for all expenses and deductions.',
  [NODE_NAMES.EARNINGS_LOSS]:
    'The residual profit loss made by a company after deducting all expenses, including operating and non-operating expenses, from total revenue. It indicates how much money the company has earned or lost during a specific time period and is a measure of its profitability.',
  [NODE_NAMES.NON_OPERATING_EXPENSE]:
    'Expenses that are not related directly to the operations of the business. This can include interest payments and taxes.',
  [NODE_NAMES.DEPRECATION_AMORTISATION_EXPENSE]:
    "D&A or Depreciation and Amortization encompass the costs incurred by a company to account for the gradual wear and tear or obsolescence of its assets. These may include buildings, machinery, patents, and other resources. D&A expense help reflect the costs of using and consuming the company's assets.",
  [NODE_NAMES.REVENUE_ELIMINATION]:
    'Eliminations ensure an accurate view of consolidated company performance by removing inter-company transactions within a corporate group, reflecting only external transactions. Additionally, other accounting adjustments may also be made as part of the elimination process.',
  [NODE_NAMES.SUM_SEGMENTS]: '',
  [NODE_NAMES.EXPENSES]:
    'A total of operating costs and non-operating costs. Operating costs are costs directly linked to the day-to-day operations of a company (like sales & marketing and research & development amongst others) while non-operating costs are incurred outside of the core operations, such as interest paid on loans or income tax paid on earnings.',
} as const;

export const MAIN_NODES = ['Sales', 'Earnings', 'Revenue', 'Expenses'];
